// Client-side file download helpers for exports (CSV / JSON).

const save = (content: string, filename: string, type: string) => {
  const blob = new Blob([content], { type });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
};

const csvCell = (v: unknown) => {
  const s = String(v ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export function downloadCsv(filename: string, headers: string[], rows: (string | number)[][]) {
  const lines = [headers.map(csvCell).join(","), ...rows.map((r) => r.map(csvCell).join(","))];
  save(lines.join("\r\n"), filename, "text/csv;charset=utf-8");
}

export function downloadJson(filename: string, data: unknown) {
  save(JSON.stringify(data, null, 2), filename, "application/json");
}
